import React from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Hero from "../components/Hero";
import "./ContactoOpciones.css";

export default function ContactoOpciones() {
  const navigate = useNavigate();

  return (
    <>
      <Hero
        subtitle="NUESTRAS VÍAS DE CONTACTO"
        title="¿Cómo querés contactarnos?"
        description="Elegí la opción que mejor se adapte a tu necesidad."
        variant="dark"
        align="center"
        height="sm"
      />

      <section className="contacto-opciones py-5">
        <Container>
          <Row className="justify-content-center g-4">
            {/* Tarjeta 1: Consulta general */}
            <Col xs={12} md={6} lg={5}>
              <Card className="contact-card h-100">
                <Card.Body className="d-flex gap-3 align-items-start">
                  {/* Icono a la izquierda */}
                  <div className="icon-left">
                    <i className="bi bi-chat-dots"></i>
                  </div>

                  {/* Contenido a la derecha */}
                  <div className="content">
                    <h5 className="card-title mb-1">Por contratación de Servicios o asesoramiento comercial</h5>
                    <p className="card-subtitle mb-3 text-muted">
                      Exclusivo para clientes o interesados en nuestros servicios.
                    </p>

                    <ul className="mb-4 text-muted">
                      <li>Presupuestos sin costo</li>
                      <li>Datos de contacto y mapa</li>
                      <li>Respuesta de nuestro equipo</li>
                      <li>Formulario simple</li>
                    </ul>
                    
                    <p class="small text-muted mt-2">
                    ⚠️ Solo para consultas de servicios o presupuestos
                    </p>

                    <Button
                      variant="warning"
                      className="btn-orange text-white fw-semibold px-4"
                      onClick={() => navigate("/contacto")}
                    >
                      Solicitar Información
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>

            {/* Tarjeta 2: Enviar Currículum */}
            <Col xs={12} md={6} lg={5}>
              <Card className="contact-card h-100">
                <Card.Body className="d-flex gap-3 align-items-start">
                  {/* Icono a la izquierda */}
                  <div className="icon-left">
                    <i className="bi bi-person-badge"></i>
                  </div>

                  {/* Contenido a la derecha */}
                  <div className="content">
                    <div className="badge-custom mb-2">Trabajá con nosotros</div>
                    <h5 className="card-title mb-1">Enviar Currículum</h5>
                    <p className="card-subtitle mb-3 text-muted">
                      Cargá tus datos para postularte a futuras vacantes.
                    </p>

                    <ul className="mb-4 text-muted">
                      <li>Datos personales y de contacto</li>
                      <li>Carga de Currículum</li>
                      <li>Estudios y referencias</li>
                      <li><strong>Envío directo a nuestra base de datos</strong></li>
                    </ul>

                    <p class="small text-muted mt-2">
                    ⚠️ Usa ésta opción para postularte
                    </p>

                    <Button
                      variant="warning"
                      className="btn-orange text-white fw-semibold px-4"
                      onClick={() => navigate("/formularioCV")}
                    >
                      Enviar Curriculum
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

